module.exports = __webpack_public_path__ + "static/media/vinsen-1.407346e6.jpg";